import { useEffect, useRef, useState } from "react";
import html from "../../components/ContentHtml/config";

export default function useLectureProgress(slug, lectureSlug, allowToggle = false) {
  const [completed, setCompleted] = useState(false);
  const [progress, setProgress] = useState({})
  const startTimeRef = useRef(Date.now());

  const PROGRESS_ENABLED = false; //disable after API setup

  
  const API_URL = window.location.hostname === "localhost"
    ?  "http://localhost:4000/api"
    : process.env.REACT_APP_API_URL
 
    useEffect(() => {  // disable after API setup
      if (!PROGRESS_ENABLED) return;

      const fetchProgress = async () => {
        try {
          const res = await fetch(`/api/progress/${slug}`);
          if (!res.ok) return;
          const data = await res.json();
          setProgress(data);
        } catch (err) {
          console.log("Progress disabled (backend not ready)");
        }
      };

      fetchProgress();
    }, [slug]);


      
  useEffect(() => {
    if (!lectureSlug) return;

    const fetchProgress = () => {
      fetch(`${API_URL}/progress/${lectureSlug}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      })
      .then(res => res.json())
      .then(data => setCompleted(!!data.completed));
    };
    fetchProgress(); 
    window.addEventListener("lectureProgressUpdated", fetchProgress);
    return () => {
       window.removeEventListener("lectureProgressUpdated", fetchProgress);
     };
  }, [lectureSlug]);

//Send the time spent when leaving the page
  useEffect(() => {
    const startTime = startTimeRef.current;

    return () => {
      const diff = Math.floor((Date.now() - startTime) / 1000);
      const study = Math.min(diff, 10800);

      fetch(`${API_URL}/progress/time`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify({
          lectureSlug,
          seconds: study
        })
      });
    };
  }, [lectureSlug]);


  const toggleComplete = async () => {
    if (!allowToggle) return;

    const res = await fetch(`${API_URL}/progress/toggle`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      body: JSON.stringify({ lectureSlug })
    });

    const data = await res.json();
    setCompleted(data.completed);
    
    window.dispatchEvent(new CustomEvent("lectureProgressUpdated"));
  };


  return { completed, toggleComplete };
};